// "Remember Me" tab scope.
//
// The session cookies (access_token / refresh_token) are shared by every tab,
// so "Remember Me" off is enforced client-side: the choice goes in
// localStorage (visible to all tabs) and the tab that logged in is marked in
// sessionStorage (per-tab - a new tab starts without it, a reload keeps it).
// Both are wiped by authStorage.clearAuth() on logout.
const REMEMBER_ME_KEY = 'cxp_remember_me'
const TAB_SESSION_KEY = 'cxp_tab_session'

export const rememberMe = {
  // Called once a login completes.
  setSessionMode: remember => {
    if (typeof window === 'undefined') {
      return
    }
    try {
      localStorage.setItem(REMEMBER_ME_KEY, remember ? 'true' : 'false')
      sessionStorage.setItem(TAB_SESSION_KEY, '1')
    } catch {
      // Storage blocked (private mode, etc.) - fall back to the shared-cookie behaviour.
    }
  },

  // The last login's choice, for calls that start a new session without the
  // login form (sidebar client switch). Defaults to true, like the backend.
  isRemembered: () => {
    if (typeof window === 'undefined') {
      return true
    }
    try {
      return localStorage.getItem(REMEMBER_ME_KEY) !== 'false'
    } catch {
      return true
    }
  },

  // False only when the last login opted out of Remember Me and this tab isn't
  // the one (or a reload/duplicate of the one) that logged in. A missing flag
  // means allowed, so sessions from before this flag existed keep working.
  isSessionAllowedInThisTab: () => {
    if (typeof window === 'undefined') {
      return true
    }
    try {
      return localStorage.getItem(REMEMBER_ME_KEY) !== 'false' || sessionStorage.getItem(TAB_SESSION_KEY) === '1'
    } catch {
      return true
    }
  }
}
